$(document).on('click', '.js-btn-login', function (e) {
	if ($(window).width() >= 768) {
		e.preventDefault();
		const $this = $(this);
		$('body').toggleClass('login-is-expanded');

		if ($('body').hasClass('login-is-expanded') && $('body').hasClass('template-index')) {
			$('.header .header__logo').addClass('js-btn-login');
		} else {
			$('.header .header__logo').removeClass('js-btn-login');
		}
	}
});
